export default function getOptions(min, max) {
  if (typeof min !== 'number' || typeof max !== 'number') {
    return null;
  }
  return [...Array(max - min + 1)] // empty array of correct length
    .map((_, index) => index + min) // set each numeric value
    .map(value => ({ label: value, value })); // convert to option object
}
